/*
 * @Description: file content
 * @Author: ljrong
 * @Date: 2024-05-08 14:35:28
 * @LastEditors: Xiaochun liu
 * @LastEditTime: 2025-03-04 10:35:40
 */
import { nanoid } from 'nanoid'
import { EMessageType, EUserType } from '../constant'
import { likeApi } from '../api'
import type { ISessionFile } from '../types'
import { getNowDate } from '../ultils'
interface IRangeList {
  rangeName: string
  docs: any[]
  type: number
  id: number
  businessId: number
}

export interface IConfig {
  content?: string
  model?: number | null
  reasoningContent?: string
  question?: string
  realQuestion?: string
  materials?: string[]
  requestId?: string
  createTime?: string
  suggestIssue?: string[]
  fileList?: ISessionFile[]
  isLoading?: boolean
  rangeList?: IRangeList[]
  reasoningTime?: string
  knowledgeFlag?: 0 | 1
}

export enum EMessageStatus {
  DEFAULT = '0',
  AGREE = '1',
  DISAGREE = '2',
}

export class Message {
  public uuid: string
  public requestId: string
  public type: EMessageType
  public role: EUserType
  public createTime: string
  public title: string
  public content: string
  public subContent: string
  public model: number | null
  public reasoningContent: string
  public question: string
  public realQuestion: string
  public status: EMessageStatus = EMessageStatus.DEFAULT
  public senceList: string[] = []
  public materials: string[] = []
  public suggestIssue: string[] = []
  public fileList: ISessionFile[] = []
  public rangeList: IRangeList[] = []
  public imgs: string[] = []
  private _docReplyType = 0
  private _showFileID: number[] = []
  private _docList: Partial<ISessionFile>[] = []
  private _isLoading = false
  public reasoningTime: string
  public knowledgeFlag: 0 | 1
  public finish: string

  constructor(type: EMessageType, config?: IConfig) {
    this.uuid = nanoid()

    this.type = type
    this.createTime = config?.createTime ? config.createTime : getNowDate()
    this.role = EUserType.ASSISTANT
    this.fileList = config?.fileList || []
    this._isLoading = config?.isLoading || false
    this.rangeList = config?.rangeList || []
    this.model = config?.model || null
    this.knowledgeFlag = config?.knowledgeFlag || 0
    this.question = config?.question || ''
    this.realQuestion = config?.realQuestion || ''
    this.reasoningContent = config?.reasoningContent || ''

    switch (type) {
      case EMessageType.PREINSTALLED:
        this.title = '你好，我是美业颜究院CoWork智能助手。'
        this.content = '作为你的智能伙伴，我既能阅读文档、存储知识，又能陪你聊天、答疑解惑。'
        this.subContent = '你可以选择下方的场景让我帮助你：'
        this.senceList = ['文件/资料查找', '知识问答', '原料建议']
        break
      case EMessageType.QUESTION:
        this.content = config?.content || ''
        this.role = EUserType.USER
        break
      case EMessageType.MATERIAL:
        this.content = config?.content || ''
        this.materials = config?.materials || []
        break
      case EMessageType.REPLY:
        this.content = config?.content || ''
        this.reasoningContent = config?.reasoningContent || ''
        break
      case EMessageType.PRE_FILE:
        this.title = '你好，我是美业颜究院CoWork智能助手。'
        this.content = '我将为您提供文件阅读辅助功能，您可以通过左侧的摘要查看本文件/资料的概要信息。\n您也可以通过问我问题来了解本文件的详细内容，节省阅读时间。'

        // 如果没有预设问题就不用参考啦
        if (config?.suggestIssue && config?.suggestIssue.length > 0) {
          this.subContent = '你可以参考一下问题：'
        }
        this.suggestIssue = config?.suggestIssue || []
        break
      case EMessageType.PREINSTALLED_MATERIAL:
        this.title = '你好，我是美业颜究院CoWork智能助手。'
        this.content = '作为你的智能伙伴，我既能阅读文档、存储知识，又能陪你聊天、答疑解惑。'
        this.subContent = '你可以选择下方的场景让我帮助你：'
        this.senceList = ['原料建议']
        break
      case EMessageType.PREINSTALLED_FIND_FILE:
        this.title = '你好，我是美业颜究院CoWork智能助手。'
        this.content = '作为你的智能伙伴，我既能阅读文档、存储知识，又能陪你聊天、答疑解惑。'
        this.subContent = '你可以选择下方的场景让我帮助你：'
        this.senceList = ['文件/资料查找']
        break
      case EMessageType.PREINSTALLED_QUESTION:
        this.title = '你好，我是美业颜究院CoWork智能助手。'
        this.content = '作为你的智能伙伴，我既能阅读文档、存储知识，又能陪你聊天、答疑解惑。'
        this.subContent = '你可以选择下方的场景让我帮助你：'
        this.senceList = ['知识问答']
        break
    }

    if (config?.requestId) {
      this.updateRequestId(config.requestId)
    }
  }

  get isLoading() {
    return this._isLoading
  }

  get docList() {
    return this._docList
  }

  /**
   * docReplyType=0 和 文档详情问答：不需要展示参考资料
   * docReplyType=1 单文档：有匹配到[num] ,就直接展示docList种文档 没有则不展示
   * docReplyType = 2 多文档： 根据[num]中数字去匹配docList种文档 没有则不展示
   */

  get filterFileList() {
    function filterDuplicateFileIds(array) {
      const seenIds = {}
      return array.filter((item) => {
        const fileId = item.fileId
        if (seenIds[fileId]) {
          return false // 如果id已经出现过，则过滤掉
        }
        seenIds[fileId] = true // 标记id已见
        return true // 否则保留
      })
    }

    if (this._docReplyType === 0) {
      return []
    }

    if (this._docReplyType === 1) {
      // 过滤列表，排除重复的文件
      const docList = filterDuplicateFileIds(this._docList)
      return docList
    }

    const list: Partial<ISessionFile>[] = []

    this._showFileID.forEach((id) => {
      const file = this._docList[id]

      if (file) {
        list.push(file)
      }
    })
    return filterDuplicateFileIds(list)
  }

  setCocReplyType(docReplyType: number) {
    this._docReplyType = docReplyType
  }

  updateRequestId(id: string) {
    this.requestId = id
  }

  async updateStatus(status: EMessageStatus) {
    if (status === EMessageStatus.DEFAULT) {
      this.status = status
      return
    }

    const res = await likeApi({
      requestId: this.requestId,
      status,
      role: this.role,
    })

    if (res) {
      this.status = status
    }

    return res
  }

  updateFinish(finish: string) {
    this.finish = finish
  }

  updateContent(text: string) {
    this.content = text
    this._isLoading = false
  }

  updateModel(model: number) {
    this.model = model
  }

  updateReasoningContent(text: string) {
    this.reasoningContent = text
    this._isLoading = false
  }

  updateFileList(list: ISessionFile[]) {
    this.fileList = list
    this._isLoading = false
  }

  updateImg(list: string[]) {
    this.imgs = list
    this._isLoading = false
  }

  joinContent(text: string) {
    const content = this.content + text
    this.content = content.replace(/(#{3,6})/g, (match: string) => `${match} `)
    this._isLoading = false
  }

  joinReasoningContent(text: string) {
    const content = this.reasoningContent + text
    this.reasoningContent = content.replace(/(#{3,6})/g, (match: string) => `${match} `)
    this._isLoading = false
  }

  updateDocList(list: Partial<ISessionFile>[]) {
    this._docList = list
    this._isLoading = false
  }

  setShowFileID(id: string) {
    this._showFileID = Array.from(new Set([...this._showFileID, Number(id) - 1])).sort()
  }

  updateReasoningTime(time: number) {
    // 计算思考时间
    const diffSeconds = Math.floor(time / 1000)
    if (diffSeconds < 60) {
      this.reasoningTime = `${diffSeconds}秒`
    } else {
      const minutes = Math.floor(diffSeconds / 60)
      const seconds = diffSeconds % 60
      this.reasoningTime = `${minutes}分${seconds}秒`
    }
  }

  updateKnowledgeFlag(knowledgeFlag: 0 | 1) {
    // 是否使用知识库回答
    this.knowledgeFlag = knowledgeFlag
  }

  // 是否停止思考
  stopThinking() {
    this._isLoading = false
    if (!this.reasoningTime) {
      this.reasoningTime = 'stopThinking'
    }
  }
}
